import { useQuery } from '@tanstack/react-query'
import { getOverviewData } from '../api'
import { getUniqueUrl } from '@/features/site-pages/api'

export function useOverview() {
  const uniqueUrl = getUniqueUrl()

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['overview', uniqueUrl],
    queryFn: () => getOverviewData(uniqueUrl),
    enabled: !!uniqueUrl,
    staleTime: 2 * 60 * 1000, // 2 minutes
  })

  return {
    overview: data || null,
    isLoading,
    error,
    refetch,
  }
}

